import shopDetailsTpl from './shop-details.tpl.html!text';

let shopDetailsConf = function($stateProvider) {
    $stateProvider.state('shop-details', {
		url: '/judet/:district/oras/:city/nume/:name/cod/:code',
        template: shopDetailsTpl,
        controllerAs: 'ctrl',
        controller: 'ShopDetailsCtrl'
	});

	$stateProvider.state('appointment', {
		url: '/programare/:code',
        template: shopDetailsTpl,
        controllerAs: 'ctrl',
        controller: 'ShopDetailsCtrl'
	});
};

shopDetailsConf.$inject = ['$stateProvider'];

export default shopDetailsConf;